exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".demo-table-expand{font-size:0}.demo-table-expand label{width:90px;color:#99a9bf}.demo-table-expand .el-form-item{margin-right:0;margin-bottom:0;width:50%}.customWidth{width:60%}.box_relative{float:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-21d6bdc5!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/order/appletOrderManager.vue
// module id = 573
// module chunks = 2